import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 80 80">
    {props.children}
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m56.4 10.3 12.3 7.1-3.1 1.8-12.3-7.1 3.1-1.8z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M65.6 19.2v12.5l-12.3-7.1V12l12.3 7.1Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M65.6 19.2v12.5l3-1.8V17.4l-3 1.8Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M15.3.3 59.8 26l-4 2.3L11.4 2.5 15.3.3zm40.5 28v44.9L11.3 47.4V2.5l44.5 25.8Z"
    />
    <path fill="#fff" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M55.8 34v39.2L11.3 47.4V8.2L55.8 34Z" />
    <path
      fill="#FAF5EF"
      d="M51.9 36v1.5l-6.3-3.7v-1.5l6.3 3.6ZM22 18.8V21l-7.4-4.3v-2.2l7.3 4.3Zm29.9 20.1v1.5l-6.3-3.6v-1.5l6.3 3.6Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M44.6 49.6c2 1.1 3.6 4 3.6 6.2 0 2.3-1.6 3.2-3.6 2l-.3-.1c-2-1.2-3.5-4-3.5-6.2 0-2.3 1.6-3.2 3.5-2l.3.1Zm-12-24c2 1.2 3.6 4 3.6 6.2 0 2.3-1.6 3.2-3.6 2l-.3-.1c-2-1.1-3.6-4-3.6-6.2 0-2.3 1.6-3.2 3.6-2l.3.1Zm3 19.5v7.6l-6.9-4v-7.6l6.9 4Zm-11.5-6.3v7.6l-6.8-4v-7.6l6.8 4Z"
    />
    <path
      fill="#FAF5EF"
      d="M24 48.5V50l-6.7-4v-1.4l6.8 4Zm11.5 6.3v1.5l-6.8-4V51l6.8 4Zm12.1 6.9v1.5l-6.8-4v-1.5l6.8 4Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M44.3 49.4v-3.6L21 32.2v4.6" />
    <path d="M13.6 7c.3.2.5.1.5-.2s-.2-.7-.5-.8c-.3-.2-.5 0-.5.2s.2.7.5.9Zm2 1.2c.3.2.5 0 .5-.3s-.2-.6-.5-.8c-.3-.1-.5 0-.5.3s.2.7.5.8Zm2 1.1c.2.2.5 0 .5-.2s-.3-.7-.5-.9c-.3-.1-.5 0-.5.3s.2.7.5.8Z" />
    <path fill="#F4EEE6" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M55.8 28.3v44.9l4-2.3V26l-4 2.3Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m22.1 63.5 4 2.3-4.4 2.5-4-2.3 4.4-2.5Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m27.6 66.5 8.8 5.2-4.5 2.6-8.8-5.1 4.5-2.7Zm8.8 7.8 9 5.5M32.5 33.7v9.7"
    />
  </svg>
);
